<template>
  <v-card>
    <v-card-title class="headline py-2">
      История изменений файла
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close-dialog')" class="mx-0"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <v-card-text>
      <v-data-table :headers="headers" :items="history" hide-actions disable-initial-sort>
        <template v-slot:items="{item}">
          <td>{{ (item.author_name) ? item.author_name : '' }}</td>
          <td class="text-xs-center">{{formatDatetime(item.created_at).middle}}</td>
          <td class="text-xs-center"><v-icon color="success" v-if="item.current">mdi-check-decagram</v-icon></td>
          <td class="text-xs-right">
            <v-tooltip top>
              <v-btn slot="activator" class="green--text mx-0" icon flat @click="viewHistory(item.id)"><v-icon>mdi-eye</v-icon></v-btn>
              <span>Просмотр</span>
            </v-tooltip>
            <v-tooltip top v-if="!item.current">
              <v-btn slot="activator" class="primary--text mx-0" icon flat @click="checkoutHistory(item.id)"><v-icon>mdi-restore</v-icon></v-btn>
              <span>Восстановить</span>
            </v-tooltip>
          </td>
        </template>
        <td slot="no-data" :colspan="headers.length" class="text-xs-center">(пусто)</td>
      </v-data-table>
    </v-card-text>
  
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" @keydown.esc="dialog=false">
      <v-card>
        <v-toolbar dark color="primary" dense>
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Предпросмотр</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="checkoutHistory(null)">Восстановить</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text v-if="snapshot" v-html="snapshot"></v-card-text>
      </v-card>
    </v-dialog>
    
  </v-card>
</template>

<script>
  import {mapGetters} from 'vuex'
  
  export default {
    name : "HistoryForm",
    
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    
    computed:{
      ...mapGetters('app/helpers',['formatDatetime']),
      ...mapGetters('app/org', ['getPostById']),
    },
    
    data(){
      return {
        history: [],
        headers: [
          { text: 'Автор изменений', align: 'left', sortable: false },
          { text: 'Дата изменеений', align: 'center', sortable: false },
          { text: 'Текущая версия', align: 'center', sortable: false },
          { text: 'Действия', align: 'right', sortable: false },
        ],
        snapshot: null,
        dialog: false,
        selectedId: null,
      }
    },
    
    created(){
      this.getHistory()
    },
    
    methods:{
      getHistory(){
        this.$store.dispatch('disk/getHistory', this.data.id).then( response => {
          this.history = response
    
          let posts = []
          this.history.map( el => {
            let post = this.getPostById(el.author.post_id)
            if(post.loaded){
              this.$set(el, 'author_name', post.name+' ('+post.fullname+')')
            } else if(!posts.includes(el.author.post_id)){
              posts.push(el.author.post_id)
            }
          })
    
          if(posts.length>0){
            this.$store.dispatch('app/org/entitiesInfo', { posts, containers: [] }).then( response => {
              this.$store.commit('app/org/addPosts', response.posts_data)
              this.history.map( el => {
                let post = this.getPostById(el.author.post_id)
                if(post.loaded){
                  this.$set(el, 'author_name', post.name+' ('+post.fullname+')')
                } else {
                  this.$set(el, 'author_name', 'Неизвестный пользователь')
                }
              })
            })
          }
        })
      },
  
      viewHistory(id){
        this.$store.dispatch('disk/viewHistory', id).then( snapshot => {
          this.snapshot = snapshot
          this.selectedId = id
          this.dialog = true
        })
      },
  
      checkoutHistory(id = null){
        if(id===null){
          id = this.selectedId
          this.dialog = false
        }
        this.$store.dispatch('disk/checkoutHistory', id).then( response => {
          if(response.current){
            this.history.map( el => {
              el.current = el.id===id
            })
            this.$emit('save', {type: 'change-history'})
          }
        }).finally( () => {
          this.selectedId = null
        })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/disk/components/Folders/Forms/HistoryForm.vue